import type { CopyShape } from "@tami/core/intl";

import type { CAMPANHAS_SCRIPT_COPY_PT_BR } from "../campanhas-script.copy";

export const CAMPANHAS_SCRIPT_COPY_ES_ES: CopyShape<typeof CAMPANHAS_SCRIPT_COPY_PT_BR> = {
  campIntro: {
    narrative: "Centro de campañas: todas tus colaboraciones con marcas organizadas desde el primer contacto hasta el cierre.",
  },
  campGrid: {
    narrative: "Guarda briefing, contactos, importes y entregables en una sola tarjeta — y sigue cada fase de la negociación.",
    callout: "Briefing, contactos e importes de cada marca — desde 'Charlando' hasta 'Terminada'.",
  },
  campModalOpen: {
    narrative: "Da de alta una campaña nueva en segundos — nombre, marca, plazo y contexto en un flujo guiado.",
    callout: "Modal de campaña: organiza colaboraciones sin salir del Centro de campañas.",
  },
  campModalTitle: {
    narrative: "Empieza por el nombre de la campaña — colección, lanzamiento o collab, todo fácil de encontrar después.",
    callout: "Ponle un nombre claro a la campaña — el punto de partida de toda negociación.",
  },
  campModalBrand: {
    narrative: "Vincula la marca colaboradora y guarda el historial de cada relación comercial.",
    callout: "Apunta qué marca está detrás de la campaña — clave para informes y finanzas.",
  },
  campModalDeadline: {
    narrative: "Define la fecha de cierre y apunta el contexto — briefing y normas en un solo sitio.",
    callout: "Plazo y contexto de la campaña — cero sorpresas a la hora de entregar.",
  },
  campModalDeliverables: {
    narrative: "En la pestaña Entregables, apunta cada pieza de la campaña: red, formato, plazo e importe.",
    callout: "Cada entregable con plataforma, formato y plazo — alcance claro desde el principio.",
  },
  campModalDeliverablesList: {
    narrative: "Todos los entregables en una tabla — estado, plazos e importes a la vista de una vez.",
    callout: "Resumen del alcance por red — Reels, vídeos y stories organizados por plataforma.",
  },
  campModalPayment: {
    narrative: "En la pestaña Pago, reparte el importe entre los entregables y define cómo vas a cobrar.",
    callout: "Importe por entregable y forma de pago — negocia con los números sobre la mesa.",
  },
  campModalPaymentTotal: {
    narrative: "Total de la campaña calculado automáticamente — pago único o a plazos, tú eliges.",
    callout: "Total de la campaña — entregas + extras, todo transparente.",
  },
  campOutro: {
    narrative: "Que el desorden no te vuelva a hacer perder el hilo de una negociación.",
  },
};
